import { CInput } from "@app/components/Common/";
import { IconSearch, IconX } from "@tabler/icons-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
// import HeaderSearchList from './HeaderSearchList'
import { ThemeContext } from "@/theme/ThemeProvider";
import styled from "styled-components";
import CloseIcon from './assets/close.svg?react';
import DarkClose from './assets/dark-close.svg?react';
import { MobileHeaderSearch, SearchInput } from "./styles";

const MHeaderSearch = ({ setOpenSearch, text, setText }) => {
  const { gray, textw } = useContext(ThemeContext).theme.COLORS;
  const {  isDarkMode, toggleTheme, } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';
  const inputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLInputElement>(null);

  const [focused, setFocused] = useState(false);
  const { t } = useTranslation();

  const handleChange = (event: any) => {
    setText(event.target.value);
  };
  const clearInput = () => {
    setText("");
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };
  const handleOutsideClick = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setFocused(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <MobileHeaderSearch ref={containerRef}>
      {/*<CButton*/}
      {/*  style={{ height: "100%" }}*/}
      {/*  icon={<IconChevronLeft color={textw} />}*/}
      {/*  onClick={() => {*/}
      {/*    setOpenSearch(false);*/}
      {/*  }}*/}
      {/*/>*/}

      <SearchInput className={"inputWithIcon"}>
        <CInput
          ref={inputRef}
          placeholder={t("searchCoin")}
          value={text}
          type={"text"}
          onChange={handleChange}
          vStyle={{
            width: "100%",
          }}
          style={{
            height: 45,
            paddingLeft: 35,
            width: "100%",
            color: '#BDBDBD',
            borderColor: focused ? '#007AFF' : "transparent",
            borderWidth: 1,
            transition: "all 0.5s ease-out",
            overflow: "hidden",
          }}
          onFocus={() => setFocused(true)}
        />
        <div className="left-icon">
          <IconSearch size={14} color={'#BDBDBD'} />
        </div>
        {text?.length ? (
          <div className="right-icon" onClick={clearInput}>
            <IconX size={12} color={theme === 'light' ? 'white' : 'black'} />
          </div>
        ) : null}
      </SearchInput>

      <CloseSVG as={theme === 'light' ? CloseIcon : DarkClose} onClick={() => {
        setOpenSearch(false);
      }}/>

      {/*{focused ? <HeaderSearchList text={text} /> : null}*/}

      {/*<CButton*/}
      {/*  style={{ height: "100%", marginInline: 18, color: '#BDBDBD' }}*/}
      {/*  title={t("cancel")}*/}
      {/*  onClick={() => {*/}
      {/*    setOpenSearch(false);*/}
      {/*  }}*/}
      {/*/>*/}
      {/* {focused ? <HeaderSearchList text={text} /> : null} */}
    </MobileHeaderSearch>
  );
};

export default React.memo(MHeaderSearch);


const CloseSVG = styled.svg`
    width: 24px;
    height: 24px;
    margin-right: 20px;
    margin-left: 12px;
`
